var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 40,
    viewBox: "0 0 26 40",
    fill: "#B1924C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7 11.4766C18.7 14.3116 16.0361 16.6099 12.75 16.6099C9.4639 16.6099 6.8 14.3116 6.8 11.4766C6.8 8.64152 9.4639 6.34323 12.75 6.34323C16.0361 6.34323 18.7 8.64152 18.7 11.4766ZM23.2219 17.7534C24.658 15.9733 25.5 13.8098 25.5 11.4766C25.5 5.40141 19.7916 0.476562 12.75 0.476562C5.70837 0.476562 0 5.40141 0 11.4766C0 13.8204 0.849689 15.9931 2.29784 17.7778L12.9094 39.5266L23.2219 17.7534Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.bab5e83d32c529f59c2f6f65586f5376.svg";
export { ForwardRef as ReactComponent };